
import { MachineComponentModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { machineComponentsStore } from '@/libs/machine-components/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({})
export default class MachineComponentSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop({ default: false }) chips!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): MachineComponentModel[] {
        const items = [...(machineComponentsStore.useGetter(CrudGetter.Data) as MachineComponentModel[])];
        return items.sort((a: MachineComponentModel, b: MachineComponentModel) => {
            return (a.code || '').localeCompare(b.code || '');
        });
    }

    mounted() {
        machineComponentsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
    }

    getDisplay(e: MachineComponentModel) {
        return `${e.code} - ${e.name}`;
    }
}
